// @ts-check
/**
 * Fokus po otevření nativního popoveru (ui-checklist bod 5; sekce 7 R-11) — jedno místo pro
 * přepínač vzhledu (`appearance.js`) i menu účtu (`account-menu.js`).
 *
 * Nemodální popover (`popover="auto"`): otevření, Esc, klik mimo a návrat fokusu na spouštěč dává
 * prohlížeč; past fokusu se nestaví. Prohlížeč po otevření fokus dovnitř nepřenese — to dělá tato
 * funkce na událost `toggle` (`newState === 'open'`). NE přes `data-autofocus`: zavaděč `app.js` by ho
 * fokusoval už při načtení stránky (popover je zavřený). Bez Popover API (jsdom, starý prohlížeč)
 * událost nepřijde a nic se neděje.
 */

/**
 * Na otevření nejbližšího popoveru (předek `scope` nebo `scope` sám) fokusuje první prvek uvnitř
 * `scope`, který odpovídá selektorům v daném POŘADÍ (první selektor se shodou vyhrává, pak první
 * shoda v DOM). Zavření fokus nemění.
 * @param {HTMLElement} scope kořen modulu, ve kterém se cíl hledá
 * @param {string[]} selectors selektory cíle od nejvhodnějšího
 * @returns {boolean} false, nemá-li `scope` předka `[popover]` (posluchač se nepřidá)
 */
export function focusOnOpen(scope, selectors) {
  const popover = scope.closest('[popover]');
  if (popover === null) return false;
  popover.addEventListener('toggle', (event) => {
    const state = /** @type {{ newState?: string }} */ (event).newState;
    if (state !== 'open') return;
    for (const selector of selectors) {
      const target = /** @type {HTMLElement | null} */ (scope.querySelector(selector));
      if (target !== null) {
        target.focus();
        return;
      }
    }
  });
  return true;
}
